module.exports = __webpack_public_path__ + "img/D202304_4.2b730d39.jpg";